import './jQueryCSV'
import { setupControlCellAria, setupSortableHeaderRole, detailsRenderer, removeCellTabStops } from '../tabel'

export function tableCSV(){

    if(document.querySelector('.js-table-csv')){
        var CsvToHtmlTable = CsvToHtmlTable || {};
        CsvToHtmlTable = {
            init: function (options) {
                options = options || {};
                var csv_path = options.csv_path || "";
                var el = options.element || "table-container";
                var allow_download = options.allow_download || false;
                var csv_options = options.csv_options || {};
                var datatables_options = options.datatables_options || {};
                var custom_formatting = options.custom_formatting || [];
                var expand_label = options.expand_label || "";
                var control_label = options.control_label || "Detaljer";
                var is_responsive = options.is_responsive || false;
                var customTemplates = {};

                $.each(custom_formatting, function (i, v) {
                    var colIdx = v[0];
                    var func = v[1];
                    customTemplates[colIdx] = func;
                });
        
                var $table = $("<table class='display table table-striped table-condensed' id='" + el + "-table'></table>");
                var $containerElement = $("#" + el);
                var captionText = $containerElement.data('caption');
                if (captionText && $table.find('caption').length === 0) {
                    $table.prepend($('<caption></caption>').text(captionText));
                }
                $containerElement.empty().append($table);
        
                $.when($.get(csv_path)).then(
                    function (data) {

                        var csvData = $.csv.toArrays(data, csv_options);
                        var $tableHead = $("<thead></thead>");
                        var csvHeaderRow = csvData[0];
                        var $tableHeadRow = $("<tr></tr>");

                        $tableHeadRow.append(
                            $("<th scope='col'></th>").append(
                                $("<span class='visually-hidden'></span>").text(control_label)
                            )
                        );

                        var hasManyRows = csvData.length > 2;
                        for (var headerIdx = 0; headerIdx < csvHeaderRow.length; headerIdx++) {
                            var headerText = (csvHeaderRow[headerIdx] || '').trim();
                            $tableHeadRow.append(hasManyRows && headerText
                                ? $("<th scope='col'></th>").append($("<button type='button' class='th-sort-toggle'></button>").text(headerText))
                                : $("<th scope='col' class='no-sort'></th>").text(headerText)
                            );
                        }
                        $tableHead.append($tableHeadRow);
        
                        $table.append($tableHead);
                        var $tableBody = $("<tbody></tbody>");
        
                        for (var rowIdx = 1; rowIdx < csvData.length; rowIdx++) {
                            var $tableBodyRow = $("<tr></tr>");
                            var $tableBodyRowTd = $("<td></td>");
                            $tableBodyRow.append($tableBodyRowTd);

                            for (var colIdx = 0; colIdx < csvData[rowIdx].length; colIdx++) {
                                // the first column names the row, so its cell is the row header
                                var $tableBodyRowTd = colIdx === 0 ? $("<th scope='row'></th>") : $("<td></td>");
                                var $paragraph = $("<p></p>")
                                var cellTemplateFunc = customTemplates[colIdx];
                                if (cellTemplateFunc) {
                                    $paragraph.html(cellTemplateFunc(csvData[rowIdx][colIdx]));
                                } else {
                                    $paragraph.text(csvData[rowIdx][colIdx]);
                                }
                                $tableBodyRowTd.append($paragraph)
                                $tableBodyRow.append($tableBodyRowTd);
                                $tableBody.append($tableBodyRow);
                            }
                        }
                        $table.append($tableBody);
        
                        var tableId = el + "-table";
                        datatables_options.initComplete = function () {
                            if (is_responsive) {
                                setupControlCellAria(tableId, expand_label);
                            }
                            setupSortableHeaderRole(tableId);
                        };
                        datatables_options.drawCallback = function () {
                            if (is_responsive) {
                                setupControlCellAria(tableId, expand_label);
                            }
                            setupSortableHeaderRole(tableId);
                        };

                        $table.DataTable(datatables_options);
                        removeCellTabStops(tableId);

                        if (is_responsive) {
                            $table.on('responsive-display.dt', function (e, datatable, row, showHide) {
                                $(row.node()).find('td.control button.control-toggle, th.control button.control-toggle')
                                    .attr('aria-expanded', showHide ? 'true' : 'false');
                            });
                        }

                        if (allow_download) {
                            $containerElement.append("<a class='btn btn__primary' href='" + csv_path + "'>Download som CSV</a>");
                        }
                    });
            }
        };

        const tables = document.querySelectorAll('.js-table-csv')
        tables.forEach(table => {
            const csvPath = table.getAttribute('data-source');
            fetch(csvPath)
                .then(response => response.text())
                .then( data => {
                    // Count commas and semicolons
                    const commaCount = (data.match(/,/g) || []).length;
                    const semicolonCount = (data.match(/;/g) || []).length;

                    const separator = semicolonCount > commaCount ? ';' : ',';
                    CsvToHtmlTable.init({
                        csv_path: table.getAttribute('data-source'),
                        element: table.id,
                        allow_download: false,
                        expand_label: table.getAttribute('data-expand-label') || '',
                        control_label: table.getAttribute('data-control-label') || 'Detaljer',
                        is_responsive: table.getAttribute('data-responsive') === 'true',
                        csv_options: {
                            separator: separator,
                            delimiter: '"'
                        },
                        datatables_options: {
                            paging: table.getAttribute('data-pagination') === 'true',
                            searching: table.getAttribute('data-searching') === 'true',
                            responsive: table.getAttribute('data-responsive') === 'true' ? {
                                details: {
                                    type: 'column',
                                    renderer: detailsRenderer
                                }
                            } : false,
                            scrollX: table.getAttribute('data-responsive') !== 'true',
                            info: table.getAttribute('data-info') === 'true',
                            lengthChange: false,
                            columnDefs: table.getAttribute('data-responsive') === 'true' ? [
                                {
                                    className: 'control',
                                    orderable: false,
                                    target: 0,
                                    visible: true
                                },
                                { orderable: false, targets: 'no-sort' }
                            ] : [
                                {
                                    className: 'control',
                                    orderable: false,
                                    target: 0,
                                    visible: false
                                },
                                { orderable: false, targets: 'no-sort' }
                            ],
                            order: [],
                            "language": {
                                "paginate": {
                                    "first": "",
                                    "last": "",
                                    "next": "",
                                    "previous": ""
                                },
                                "lengthMenu": "Vis _MENU_ linjer",
                                "info": "Viser _START_ til _END_ af _TOTAL_ linjer",
                                "infoFiltered": "(filtreret fra _MAX_ linjer)",
                                "search": "Søg",
                                "searchPlaceholder": "Søg",
                                "searchBuilder": {
                                    "value": "Søg",
                                },
                                "layout": {
                                    "top1": "searchBuilder"
                                } 
                            }
                        }/* ,
                        custom_formatting: [
                            [4, format_link]
                        ] */
                    });
                })


            table.querySelectorAll('table').forEach(el => {
                el.setAttribute('summary', table.getAttribute('data-summary'))
            })
        })

    }
}

export default tableCSV